import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeadersModule } from '@shared/core/components/headers';
import { ButtonsModule } from '@shared/core/components/buttons';
import { MaxOnScreenHeightDirectiveSharedModule } from '@shared/core/directives/maxOnScreenHeight/max-on-screen-height.directive.shared.module';

import { CartComponentsModule } from '../../components';
//import { CartDirectivesModule } from '@shared/core/directives';

import { CartForDefaultComponent } from './cart-for-default.shared.component';

@NgModule({
    declarations: [
        CartForDefaultComponent
    ],
    imports: [
        CommonModule,
        CartComponentsModule,
        HeadersModule,
        ButtonsModule,
        MaxOnScreenHeightDirectiveSharedModule,
    ],
    exports: [
        CartForDefaultComponent,
    ],
    providers: [],
})
export class CartForDefaultModule { }
